const AUTH_BASE = window.DoomgangAuthBase || 'https://artists.doomgang.xyz';
const addressPattern = /^0x[a-fA-F0-9]{40}$/;

function getInjectedProvider() {
  const injected = window.ethereum;
  if (!injected) return null;
  if (Array.isArray(injected.providers)) {
    return injected.providers.find((item) => typeof item?.request === 'function') || null;
  }
  return typeof injected.request === 'function' ? injected : null;
}

async function fetchSession() {
  const res = await fetch(AUTH_BASE + '/api/auth/session', { credentials: 'include', cache: 'no-store' });
  if (!res.ok) throw new Error('session check failed');
  return res.json();
}

async function connectWallet(dialog, statusEl, addressEl, connectBtn, disconnectBtn) {
  const provider = getInjectedProvider();
  if (!provider) {
    statusEl.textContent = 'no injected wallet found. open this page inside a wallet browser, or use shopify email sign-in for checkout.';
    return;
  }
  connectBtn.disabled = true;
  statusEl.textContent = 'requesting wallet permission…';
  try {
    const accounts = await provider.request({ method: 'eth_requestAccounts' });
    const account = Array.isArray(accounts) ? accounts[0] : null;
    if (typeof account !== 'string' || !addressPattern.test(account)) throw new Error('wallet returned no valid ethereum address');

    statusEl.textContent = 'fetching challenge…';
    const nonceRes = await fetch(AUTH_BASE + '/api/auth/wallet/nonce', {
      method: 'POST', credentials: 'include', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ address: account }),
    });
    const nonce = await nonceRes.json();
    if (!nonceRes.ok || !nonce.ok || typeof nonce.message !== 'string') throw new Error(nonce.error || 'wallet challenge failed');

    statusEl.textContent = 'signing challenge…';
    const signature = await provider.request({ method: 'personal_sign', params: [nonce.message, account] });
    if (typeof signature !== 'string') throw new Error('wallet did not sign the challenge');

    statusEl.textContent = 'verifying signature…';
    const verifyRes = await fetch(AUTH_BASE + '/api/auth/wallet/verify', {
      method: 'POST', credentials: 'include', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ address: account, message: nonce.message, signature }),
    });
    const verified = await verifyRes.json();
    if (!verifyRes.ok || !verified.ok) throw new Error(verified.error || 'wallet verification failed');

    statusEl.textContent = 'confirming session…';
    const session = await fetchSession();
    if (!session.authenticated || session.session?.method !== 'wallet' || session.session?.address?.toLowerCase() !== account.toLowerCase()) {
      throw new Error('session was not saved; wallet connection is not complete');
    }

    addressEl.textContent = 'connected: ' + account.slice(0, 6) + '\u2026' + account.slice(-4);
    statusEl.textContent = 'wallet session active.';
    connectBtn.hidden = true;
    disconnectBtn.hidden = false;
  } catch (error) {
    addressEl.textContent = '';
    statusEl.textContent = error instanceof Error ? error.message : 'wallet connection cancelled.';
    connectBtn.disabled = false;
  }
}

async function disconnectWallet(dialog, statusEl, addressEl, connectBtn, disconnectBtn) {
  disconnectBtn.disabled = true;
  statusEl.textContent = 'disconnecting…';
  try {
    const res = await fetch(AUTH_BASE + '/api/auth/wallet/logout', { method: 'POST', credentials: 'include' });
    if (!res.ok) throw new Error('wallet disconnect failed');
    const session = await fetchSession();
    if (session.authenticated) throw new Error('session still active; retry disconnect');
    addressEl.textContent = '';
    statusEl.textContent = 'wallet session disconnected.';
    connectBtn.hidden = false;
    connectBtn.disabled = false;
    disconnectBtn.hidden = true;
  } catch (error) {
    statusEl.textContent = error instanceof Error ? error.message : 'wallet disconnect failed';
    disconnectBtn.disabled = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.getElementById('dg-wallet-modal');
  if (!dialog) return;
  const trigger = document.querySelector('[data-wallet-modal-trigger]');
  const closeBtn = dialog.querySelector('.dg-wallet-modal__close');
  const statusEl = dialog.querySelector('.dg-wallet-modal__status');
  const addressEl = dialog.querySelector('.dg-wallet-modal__address');
  const connectBtn = dialog.querySelector('.dg-wallet-modal__connect');
  const disconnectBtn = dialog.querySelector('.dg-wallet-modal__disconnect');

  if (trigger) {
    trigger.addEventListener('click', async () => {
      dialog.showModal();
      statusEl.textContent = 'checking session…';
      addressEl.textContent = '';
      connectBtn.hidden = false;
      connectBtn.disabled = false;
      disconnectBtn.hidden = true;
      try {
        const session = await fetchSession();
        if (session.authenticated && session.session?.method === 'wallet' && addressPattern.test(session.session.address ?? '')) {
          addressEl.textContent = 'connected: ' + session.session.address.slice(0, 6) + '\u2026' + session.session.address.slice(-4);
          statusEl.textContent = 'wallet session active.';
          connectBtn.hidden = true;
          disconnectBtn.hidden = false;
        } else {
          statusEl.textContent = 'connect an ethereum wallet to verify ownership.';
        }
      } catch {
        statusEl.textContent = 'session check unavailable. try again.';
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
  if (connectBtn) connectBtn.addEventListener('click', () => connectWallet(dialog, statusEl, addressEl, connectBtn, disconnectBtn));
  if (disconnectBtn) disconnectBtn.addEventListener('click', () => disconnectWallet(dialog, statusEl, addressEl, connectBtn, disconnectBtn));

  // Close on backdrop click
  dialog.addEventListener('click', (e) => {
    const rect = dialog.querySelector('.dg-wallet-modal__inner').getBoundingClientRect();
    if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
      dialog.close();
    }
  });
});
